import { Component } from '@angular/core';
import { HttpClient, HttpClientModule } from '@angular/common/http'
import { environment } from '../environments/environment'
import { FormGroup, FormControl } from '@angular/forms';

export type FormInterface = { digital_signature : string };

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'online-policy-verification';

  digiSign: any;
  digital_signature: any;
  errMsg: string
  isError: boolean = false;
  _spinner: boolean = false;
  digiSignError : string;


  constructor( private http: HttpClient) {
    this.isError = false;
    this.errMsg = '';
    this. digiSignError = '';
    //this.digital_signature = 'DI-2020%2FFA305146';
  }

  ngOnInit(){
    //this.onSubmit(this.digital_signature);
  }


  onSubmit(digital_signature) {
    this.isError = false;
    this.errMsg = '';
    this._spinner = true;
    if(digital_signature == null){
      this.isError = true;
      this._spinner = false;
      this.errMsg = 'This field is required'
    }
    else{
      this.http.get(environment.apiUrl + '/v1/policy/verify?digital_signature=' + digital_signature)
      .subscribe(data => {
        this._spinner = false;
        this.digiSign = data;
        console.log('digising', data);  
        console.log('environment.apiUrl', environment.apiUrl);  
      }, err => {
        if (err.status == "400"){
          this.errMsg = err.error.error_message;
          this.digiSignError = err.error.errors.digital_signature[0];
          console.log("digiSignError", this.digiSignError)
          this.isError = true;
          this._spinner = false;
          //this.errMsg = err.error_message
          console.log("err", err)
        }
       
      })
    }
    
  }
}
